// extracted by mini-css-extract-plugin
export default {"page":"wrapper_page__d+yng","container":"wrapper_container__FsFyj","body":"wrapper_body__Nl3qq"};